import { Component, computed, inject } from "@angular/core"
import { RouterLink, RouterLinkActive } from "@angular/router"
import { ProfileService } from "./user-profile/profile.service"
import { RouteService } from "../services/route.service"
import { TourService } from "./tour/tour.service"
import { PageMenuService } from "./page-menu.service"
import { UiDrawerComponent } from "ui-drawer"
import { RegionsService } from "../regions/regions.service"
import { UserLoginService } from "./user-login/user-login.service"
import { regionsData } from "redlineLibs"

@Component({
  imports: [
    RouterLink,
    RouterLinkActive,
    UiDrawerComponent,
  ],
  standalone: true,
  template: `
    <lib-ui-drawer 
      [show]="showMenu()"
      (cancelAndClose)="hidePageMenu()"
    >
      <div
        class="pl-10 bg-base-200 text-base-content w-72" 
        (click)="hidePageMenu()"
      >
        <nav aria-label="Main Menu" class="border-l-8 border-dashed border-primary">
          <ul class="menu p-2">
            @if (audioTour()) {
              <li>
                <a
                  tabindex="0"
                  role="button"
                  [routerLink]="[]" 
                  (click)="clickVirtualTour($event)"
                >
                  Virtual Tour (pre-alpha)
                </a>
              </li>
            }
            <li>
              <a
                routerLink="/introduction"
                routerLinkActive="text-primary font-bold"
              >
                Introduction
              </a>
            </li>
            <li>
              <a
                routerLink="/redline-map"
                routerLinkActive="text-primary font-bold"
              >
                {{ redliningTitle() }}
              </a>
            </li>
            <li>
              <a
                routerLink="/timeline"
                routerLinkActive="text-primary font-bold"
              >
                Interactive Timeline
              </a>
            </li>
            <li>
              <a
                routerLink="/stories-map"
                routerLinkActive="text-primary font-bold"
              >
                {{ storiesTitle() }}
              </a>
            </li>
            <!--
                        <li>
                          <a
                            routerLink="/undesign"
                            routerLinkActive="text-primary font-bold"
                          >
                            How do we Undesign?
                          </a>
                        </li>
            -->
            @if (loggedIn() === null) {
              <li>
                <a
                  [routerLink]="[]"
                  [queryParams]="queryParamsList().myAccountLogin"
                >
                  LOGIN
                </a>
              </li>
            }
            @if (loggedIn()) {
              <li>
                <a
                  [routerLink]="[]"
                  (click)="logout($event)"
                >
                  LOG OUT
                </a>
              </li>
            }
            @if (isUserAdmin()) {
              <li>
                <a
                  routerLink="/users"
                  routerLinkActive="text-primary font-bold"
                >
                  Manage Users
                </a>
              </li>
            }
          </ul>
        </nav>
      </div>
    </lib-ui-drawer>
  `,
  selector: "e2e-page-menu",
})
export class PageMenuComponent {
  private profileService = inject(ProfileService)
  private routeService = inject(RouteService)
  private tourService = inject(TourService)
  private pageMenuService = inject(PageMenuService)
  private userLoginService = inject(UserLoginService)
  private regionService = inject(RegionsService)

  audioTour = computed(() =>
    regionsData[this.routeService.region()].audioTour
  )

  queryParamsList = this.routeService.queryParamsList

  redliningTitle = computed(() =>
    regionsData[regionsData[this.routeService.region()].redliningRegion].titleRedlining
  )

  storiesTitle = computed(() =>
    regionsData[this.routeService.region()].titleStories
  )

  regionLabel = computed(() =>
    this.regionService.brandHeader()?.title
  )
  loggedIn = this.profileService.loggedIn
  isUserAdmin = this.profileService.isUserAdmin

  showMenu = this.pageMenuService.showMenu

  hidePageMenu() {
    this.pageMenuService.unsetShowMenu()
  }

  setShowTour(showTour: boolean) {
    this.tourService.setShowTour(showTour)
  }

  clickVirtualTour(event: Event) {
    event.stopPropagation()
    this.setShowTour(true)
    this.hidePageMenu()
  }

  logout(event: Event) {
    event.preventDefault()
    this.userLoginService.signOut()
    this.hidePageMenu()
  }

}
